/** @jsxImportSource @emotion/react */
import { Route, Routes } from 'react-router-dom';
import { WalletDetails, WalletList } from './components';

export const Wallets = () => {
  return (
    <Routes>
      <Route path="/" element={<WalletList />} />
      <Route path="/:walletId" element={<WalletDetails />} />
    </Routes>
  );
};
